import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { getLink } from "../../dataProvider/links.js"

import iconProductNormal from '../../img/v2/pricing/ic-product-normal.svg'
import iconProductSelfEmployed from '../../img/v2/pricing/ic-product-selfEmployed.svg'
import iconProductCompany from '../../img/v2/pricing/ic-product-company.svg'
import iconArrowUp from '../../img/v2/pricing/ic-blue-arrow-up.svg'

import "../../scss/v2/pricing.scss"

const icons = {
    normal: iconProductNormal,
    selfEmployed: iconProductSelfEmployed,
    company: iconProductCompany,
}

function PricingBlock({ products, headTitle }) {

    const { t } = useTranslation();

    return (
        <div className='container' >
            <div className='pricing-block' >
                {headTitle ? <h1 className='pricing-head-title'  >{t('pricing.title')}</h1> : <h2 className='pricing-title' >{t('pricing.title')}</h2>}
                <div className='row' >
                    {products.map(product => <Product product={product} headTitle={headTitle} key={product.type} />)}
                </div>
            </div>
        </div>
    )
}

function Product({ product, headTitle }) {

    const { t, i18n } = useTranslation();

    function handleButtonClick() {
        window.scrollTo(0, 0)
    }

    return (
        <div className='col-12 col-lg-4' >
            <div className='product' >
                <div className='row' >
                    <div className='col-8' >
                        {headTitle ?
                            <h2 className='product-title'  >{t(`pricing.${product.type}.title`)}</h2> :
                            <h3 className='product-title' >{t(`pricing.${product.type}.title`)}</h3>
                        }
                        <p className='product-description' >{t(`pricing.${product.type}.description`)}</p>
                    </div>
                    <div className='col-4' >
                        <img className='img-fluid' src={icons[product.type]} />
                    </div>
                </div>
                <p className='product-price' >
                    <span>{product.subPrice}</span>
                    {t(`pricing.${product.type}.month`)}
                </p>
                <Link to={getLink("home", i18n.language)} onClick={handleButtonClick} >
                    <button className="product-button">{t(`pricing.${product.type}.button`)}</button>
                </Link>
                <div className='text-center' >
                    <img src={iconArrowUp} />
                </div>
                <p className='product-acq' >{t(`pricing.${product.type}.acq`, { acqPrice: product.acqPrice })}</p>
                <div className='product-usage' >
                    <p className={`product-usage-element ${product.type === 'selfEmployed' ? 'product-usage-element-selfEmployed' : ''} ${product.type === 'company' ? 'product-usage-element-company' : ''}`} dangerouslySetInnerHTML={{ __html: t(`pricing.${product.type}.usage1`) }} />
                    <p className={`product-usage-element ${product.type === 'selfEmployed' ? 'product-usage-element-selfEmployed' : ''} ${product.type === 'company' ? 'product-usage-element-company' : ''}`} dangerouslySetInnerHTML={{ __html: t(`pricing.${product.type}.usage2`) }} />
                    <p className={`product-usage-element`} dangerouslySetInnerHTML={{ __html: t(`pricing.${product.type}.usage3`) }} />
                </div>
                <div className='product-access' >
                    {
                        // Update array length to 9 later
                    }
                    {Array.from({ length: 7 }).map((_, index) => (
                        <div key={index} className={`product-access-element ${product.type !== 'company' && index > 6 ? 'product-access-element-off' : ''}`} >{t(`pricing.${product.type}.access${index + 1}`)}</div>
                    ))}
                </div>
            </div>
        </div>
    )

}

const mapStateToProps = state => ({ products: state.product.products });

export default connect(mapStateToProps, null)(PricingBlock);